import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _objectSpread from "@babel/runtime/helpers/esm/objectSpread";
import consola from 'consola';
import * as types from './types';
import { createCart, fetchCart, addCart, updateCart } from // addCartCustomizable,
'~/services/cart';

const formatMinicart = items => items.reduce((acc, item) => _objectSpread({}, acc, {
  [item.reference]: {
    id: item.id,
    quantity: item.quantity
  }
}), {});

const getGraphQLErrorsCode = err => {
  if (err.graphQLErrors && err.graphQLErrors.length) {
    return err.graphQLErrors[0].extensions.code || '';
  }

  return '';
};

export default {
  fetchCart(_ref) {
    var _this = this;

    return _asyncToGenerator(function* () {
      let {
        commit
      } = _ref;
      const token = window.localStorage.MDM_CART_TOKEN;

      if (!token) {
        return;
      }

      try {
        const {
          minicart
        } = yield fetchCart(_this, token);
        const newCartItems = formatMinicart(minicart.items);
        commit(types.SET_CART_QTY, minicart.quantity);
        commit(types.SET_CART, newCartItems);
      } catch (err) {
        const code = getGraphQLErrorsCode(err);

        if (code === 'MERCURE_ERROR_CART_NOTFOUND') {
          localStorage.removeItem('MDM_CART_TOKEN');
        } else {
          consola.error(err);

          if (_this.$sentry) {
            _this.$sentry.captureException(err);
          }
        }
      }
    })();
  },

  addCart(_ref2, payload) {
    var _this2 = this;

    return _asyncToGenerator(function* () {
      let {
        commit
      } = _ref2;

      try {
        let token = window.localStorage.MDM_CART_TOKEN;

        if (!token) {
          const {
            createNewCart
          } = yield createCart(_this2);

          if (!createNewCart) {
            throw new Error('MDM_CART_CANNOT_CREATE_TOKEN');
          }

          token = createNewCart;
          window.localStorage.MDM_CART_TOKEN = token;
        }

        const {
          addProductsToCart
        } = yield addCart(_this2, _objectSpread({
          token
        }, payload));
        commit(types.SET_CART, formatMinicart(addProductsToCart.items));
        commit(types.SET_CART_QTY, addProductsToCart.quantity);
        commit(types.SET_CART_SUCCESS, true);
      } catch (err) {
        commit(types.SET_CART_SUCCESS, false);
        consola.error(err);

        if (_this2.$sentry) {
          _this2.$sentry.captureException(err);
        }
      }
    })();
  },

  // async addCartCustomizable({ commit }, payload) {
  //   // TODO
  //   const data = await addCartCustomizable(this, payload);
  //   if (data.success) {
  //     commit(types.PUSH_CART, { quantity: 1 });
  //     commit(types.SET_CART_SUCCESS, true);
  //   } else {
  //     commit(types.SET_CART_SUCCESS, false);
  //   }
  // },
  updateCart(_ref3, payload) {
    var _this3 = this;

    return _asyncToGenerator(function* () {
      let {
        commit
      } = _ref3;

      try {
        const token = window.localStorage.MDM_CART_TOKEN;

        if (!token) {
          throw new Error('MDM_CART_TOKEN_UNDEFINED');
        }

        const {
          id
        } = _this3.state.cart.items[payload.reference];
        const {
          updateCartItems
        } = yield updateCart(_this3, _objectSpread({
          token,
          id
        }, payload));
        commit(types.SET_CART, formatMinicart(updateCartItems.items));
        commit(types.SET_CART_QTY, updateCartItems.quantity);
        commit(types.SET_CART_SUCCESS, true);
      } catch (err) {
        commit(types.SET_CART_SUCCESS, false);
        consola.error(err);

        if (_this3.$sentry) {
          _this3.$sentry.captureException(err);
        }
      }
    })();
  }

};